import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MainService } from '../../../core/services/utilities/main.service';

import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [ProgressSpinnerModule],
  templateUrl: './loading.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loading.scss']
})
export class LoadingComponent implements OnInit, OnDestroy {
  isLoading = false;
  private loadingSubscription!: Subscription;

  constructor(private mainService: MainService) {}

  ngOnInit(): void {
    this.loadingSubscription = this.mainService.loading$.subscribe(
      (loading: boolean) => (this.isLoading = loading)
    );
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe();
  }
}